export default {
  redirectUrl: '',
  sidebar: false,
  numberOfElements: 4,
};
